/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_UnlockInputs */



/**
* | output |
* | --- |
* | "Unlock" |
*
* @param {Event_Group_Options_UnlockInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_unlock = /** @type {((inputs?: Event_Group_Options_UnlockInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_UnlockInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Unlock")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unlock")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unlock")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Unlock")
	if (locale === "es") return /** @type {LocalizedString} */ ("Unlock")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Unlock")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Unlock")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Unlock")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Unlock")
	return /** @type {LocalizedString} */ ("Unlock")
});